export default __webpack_public_path__ + "static/l4-651a6c6bfba091139d20dda705c3d8af.png";